import LegacySelect from "./Select";
import SelectRedesign from "../../redesign/elements/Select";

const useNewDesign = process.env.REACT_APP_FEATURE_NEW_DESIGN === "true";

export type { SelectOptionType } from "./Select";

export default useNewDesign ? SelectRedesign : LegacySelect;
